import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Email, Lock } from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom'
import axios from 'axios';

const LOGO_PATH = './full-logo.svg';

const useStyles = makeStyles({
  sop: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#e8ecf1',
  },
  logo: {
    width: 300,
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

export function ResetPassword() {
  const classes = useStyles();
  const [email, setEmail] = useState<string>();
  const [oldPassword, setOldPassword] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [confirmPassword, setConfirmPassword] = useState<string>();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>();
  const [isFetch, setIsFetch] = useState(false);

  function submit() {
    if (password !== confirmPassword) {
      setToastMessage('Confirm password does not match new password');
      setShowToast(true);
      return;
    }

    if (password === oldPassword) {
      setToastMessage('New password should be different from the old one');
      setShowToast(true);
      return;
    }
    
    if (email && password && oldPassword) {
      setIsFetch(true);
      axios({
          url: `${process.env.REACT_APP_BASE_API_URL}/api/WHCPortal/ResetPassword`,
        method: 'GET',
        headers: {
          email: email,
          password: oldPassword,
          newPassword: password,
        },
      })
        .then((res) => {
          setToastMessage('Success');
          setShowToast(true);
        })
        .catch((err) => {
          setToastMessage(err.response.data);
          setShowToast(true);
        })
        .finally(() => {
          setIsFetch(false);
        });

        return;
    } else {
      setToastMessage('Please Fill All Form Data');
      setShowToast(true);
    }
  }

  return (
    <Stack>
      <div className={classes.sop}>
        <div>
          <img className={classes.logo} src={LOGO_PATH} alt='Logo'></img>
        </div>
        <div style={{ marginTop: 20, maxWidth: 450 }}>
          <Card>
            <CardContent>
              <div className={classes.textContainer}>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 900, color: 'black' }}
                  gutterBottom
                >
                  Change Your Password
                </Typography>
                <Typography
                  sx={{ fontSize: 14, color: '#aeaeae' }}
                  gutterBottom
                >
                  Enter your credentials to change your password
                </Typography>
              </div>
              <div style={{ marginTop: 30 }}>
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  label='Email'
                  placeholder='Enter Your Email'
                  variant='outlined'
                  size='small'
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Email></Email>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  onChange={(e) => setOldPassword(e.target.value)}
                  type='password'
                  label='Old Password'
                  placeholder='Enter your old password'
                  size='small'
                  fullWidth
                  variant='outlined'
                  style={{ marginTop: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Lock></Lock>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  onChange={(e) => setPassword(e.target.value)}
                  type='password'
                  label='New Password'
                  placeholder='Enter your new password'
                  size='small'
                  fullWidth
                  variant='outlined'
                  style={{ marginTop: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Lock></Lock>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type='password'
                  label='Confirm New Password'
                  placeholder='Enter your new password'
                  size='small'
                  fullWidth
                  variant='outlined'
                  style={{ marginTop: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Lock></Lock>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  onClick={() => submit()}
                  fullWidth
                  style={{ marginTop: 20 }}
                  variant='contained'
                >
                  {isFetch ? <CircularProgress size={25} color='inherit' /> : 'Submit'}
                </Button>
              </div>
            </CardContent>
          </Card>
          <div className={classes.textContainer} style={{marginTop: 20}}>
            <Link to="/login">
              Back to Login Page
            </Link>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={showToast}
        autoHideDuration={3000}
        onClose={() => setShowToast(false)}
        message={toastMessage}
      />
    </Stack>
  );
}
